var contentful = require('contentful');


const client = contentful.createClient({
  space: 'vl25w17wkeru',
  accessToken: 'fMZeOO23fA74gYwUnPyX83l7N_g-YwZz6nX_gSbDVf4',
});

export {client};
